import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/CVC_logo.png'
import _imports_1 from '../assets/Innovatech_logo.png'
import _imports_2 from '../assets/Serpa_logo.png'
import _imports_3 from '../assets/Correct_Pack_logo.png'
import _imports_4 from '../assets/Riqtech_logo.png'
import _imports_5 from '../assets/Mekitec_logo.png'
import _imports_6 from '../assets/Fumex_logo.png'


const _hoisted_1 = {
  class: "hero p-2",
  style: {"background-color":"#f4f4f6"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "block pt-6" }
const _hoisted_4 = {
  key: 0,
  class: "colums is-mobile"
}
const _hoisted_5 = { class: "column is-10 is-offset-1" }
const _hoisted_6 = {
  key: 1,
  class: "colums is-mobile"
}
const _hoisted_7 = { class: "column is-8 is-offset-2" }
const _hoisted_8 = {
  class: "has-text-centered has-text-primary",
  style: {"font-family":"Calibri"}
}
const _hoisted_9 = { class: "column" }
const _hoisted_10 = { class: "card representadas" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_0,
      alt: "CVC_logo.png"
    })
  ])
], -1)
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_14 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "card representadas" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_1,
      alt: "Innovatech_logo.png"
    })
  ])
], -1)
const _hoisted_18 = { class: "card-content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_20 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_21 = { class: "column" }
const _hoisted_22 = { class: "card representadas" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_2,
      alt: "Serpa_logo.png"
    })
  ])
], -1)
const _hoisted_24 = { class: "card-content" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_26 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_27 = { class: "column" }
const _hoisted_28 = { class: "card representadas" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_3,
      alt: "Correct_Pack_logo.png"
    })
  ])
], -1)
const _hoisted_30 = { class: "card-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_32 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_33 = { class: "column" }
const _hoisted_34 = { class: "card representadas" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_4,
      alt: "Riqtech_logo.png"
    })
  ])
], -1)
const _hoisted_36 = { class: "card-content" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_38 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_39 = { class: "column" }
const _hoisted_40 = { class: "card representadas" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_5,
      alt: "Mekitec_logo.png"
    })
  ])
], -1)
const _hoisted_42 = { class: "card-content" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_44 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_45 = { class: "column" }
const _hoisted_46 = { class: "card representadas" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card-image p-4" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "has-ratio",
      src: _imports_6,
      alt: "Fumex_logo.png"
    })
  ])
], -1)
const _hoisted_48 = { class: "card-content" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", {
  class: "pl-6 pr-6 pb-5 has-text-blue",
  style: {"font-family":"Calibri"}
}, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh ", -1)
const _hoisted_50 = {
  class: "is-bold pl-6 pr-6 pb-4",
  style: {"font-family":"Calibri","font-weight":"600"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)

import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'RepresentadasComponent',
  props: {
    hasTitle: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.hasTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", {
                  class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
                  style: {"font-family":"Calibri","font-weight":"bold"}
                }, " REPRESENTAMOS MARCAS SEGURAS, EFICIENTES Y DURABLES ", 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(" Nos hemos aliado estratégicamente con marcas destacadas en sus respectivas especialidades, con el objetivo de mejorar la eficiencia en la producción, reducir los costos operativos y elevar la calidad de los productos para beneficio de nuestros clientes. "),
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Conoce toda la gama de nuestros equipos.")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["columns is-variable pt-6", _unref(width) < 768 ? '' : 'is-7'])
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("p", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("p", _hoisted_26, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["columns is-variable", _unref(width) < 768 ? '' : 'is-7'])
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("p", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("p", _hoisted_38, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("p", _hoisted_44, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["columns is-variable pb-6", _unref(width) < 768 ? '' : 'is-7'])
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("p", _hoisted_50, [
                  _createVNode(_component_router_link, {
                    to: "/equipo",
                    class: "is-transparent has-text-yellow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver equipos ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _hoisted_51,
          _hoisted_52
        ], 2)
      ])
    ])
  ]))
}
}

})